import request from './axios'
import { senBaseUrl } from './config'

// 根据渠道id获取落地页图片
export const getLandingPageApi = (params) => request({
    url: senBaseUrl+'/empmng/app/api/channel/style/getByChannelId',
    meta: {
        isToken: false
    },
    method: 'get',
    params: params
})

// 通过fileUrl生成预签名url
export const getPreviewUrlApi = (params) => request({
    url: senBaseUrl+'/empmng/common/api/sys/cos/generatePresignedUrlByUrl',
    meta: {
        isToken: false
    },
    method: 'post',
    data: params
})

// 获取二维码
export const getQRCodeApi = (params) => request({
    url: senBaseUrl+'/empmng/app/api/channel/channel/downloadQrCode',
    meta: {
        isToken: false
    },
    method: 'get',
    params: params,
    responseType: 'blob'
})

